<div class="item" *ngFor="let databaseSyncStatus of databasesSyncStatus">
	<calao-database-sync-status [databaseSyncStatus]="databaseSyncStatus"></calao-database-sync-status>
</div>